// extracted by css-extract-rspack-plugin
export default {"sortingFields":"SortingFields__sortingFields--d5wsg","limitOnly":"SortingFields__limitOnly--BsqnF"};